/**
 * @description 二维码相关
 * @created 2023/09/19 13:40:55
*/
import QRCode from "qrcode"
import qrcodeParser from "qrcode-parser"

/**
 * @description 生成二维码
 * @created 2024/04/27 14:41:15
 */
export function generateQRCode({ width, height, content, dark }, callback) {
  // toString 比 toDataURL 快 10 倍左右
  QRCode.toString(content, {
    width,
    height,
    margin: 0,
    color: {
      dark
    }
  }, (err, url) => {
    if (err) console.error(err)
    else callback(url)
  })
}

/**
 * @description 解析图片中的二维码内容
 * @created 2024/04/27 14:40:41
 */
export function decodeQRcode(file) {
  return new Promise((resolve) => {
    qrcodeParser(file).then((result) => {
      resolve(result)
    }).catch(() => {
      resolve(null)
    })
  })
}
